export class CarrierImportParseError {

  public lineNumber: number;
  public columnNumber: number;
  public fieldName: string;
  public fieldValue: string;
  public message: string;
  public identity: string;
  public type: 'MISSING'|'CMAWEB_DUPLICATE'|'FILE_DUPLICATE'|'INEXISTANT'|'INVALID';

  static fromDto(data: any): CarrierImportParseError {
    if (!data) {
      return null;
    }

    const parseError = new CarrierImportParseError();

    parseError.lineNumber   = data.line_number;
    parseError.columnNumber = data.column_number;
    parseError.fieldName    = data.field_name;
    parseError.fieldValue   = data.field_value;
    parseError.message      = data.message;
    parseError.identity     = data.identity;

    return parseError;
  }

  static toDtos(data: CarrierImportParseError[]) {
    return data.map(d => ({
      line_number: d.lineNumber,
      column_number: d.columnNumber,
      field_value: d.fieldValue,
      field_name: d.fieldName,
      message: d.message,
      identity: d.identity
    }));
  }
}
